import { format, parseISO, isThisYear, isValid, formatRelative } from "date-fns";

const safeParseISO = (dateStr: string): Date | null => {
  if (!dateStr) return null;
  const parsedDate = parseISO(dateStr);
  return isValid(parsedDate) ? parsedDate : null;
};

export const toDefaultDateFormat = (dateStr: string | null, dateFormat = "dd/MM/yyyy") => {
  if (!dateStr) return "";
  try {
    const date = safeParseISO(dateStr);
    if (!date) return "";
    return format(date, dateFormat);
  } catch {
    return "";
  }
};

export const toRelativeDate = (dateStr: string | null) => {
  if (!dateStr) return "";
  const date = safeParseISO(dateStr);
  if (!date) return "";
  return formatRelative(date, new Date());
};

export const toDefaultDateTimeFormat = (dateStr: string | null) => {
  if (!dateStr) return "";
  const date = safeParseISO(dateStr);
  if (!date) return "";
  return format(date, "dd/MM/yyyy, HH:mm:ss");
};

export const formatTimeToAmPm = (dateStr: string | null) => {
  if (!dateStr) return "";
  try {
    const date = safeParseISO(dateStr);
    if (!date) return "";
    return format(date, "h:mm a");
  } catch {
    return "";
  }
};

export const formatDateToShort = (dateStr: string | null) => {
  if (!dateStr) return "";
  try {
    const date = safeParseISO(dateStr);
    if (!date) return "";
    return format(date, "MMM d, yyyy");
  } catch {
    return "";
  }
};

export const toDayNameFormat = (dateStr: string | null) => {
  if (!dateStr) return "";
  try {
    const date = safeParseISO(dateStr);
    if (!date) return "";
    return format(date, "EEEE");
  } catch {
    return "";
  }
};

export const toDetailedDateTimeFormat = (dateStr: string | null) => {
  if (!dateStr) return "";
  try {
    const date = safeParseISO(dateStr);
    if (!date) return "";
    return format(date, "EEE, dd MMM yyyy 'at' HH:mm");
  } catch {
    return "";
  }
};

export const toDayMonthNameFormat = (dateStr: string | null) => {
  if (!dateStr) return "";
  try {
    const date = safeParseISO(dateStr);
    if (!date) return "";
    return format(date, isThisYear(date) ? "EEEE, MMMM d" : "EEEE, MMMM d, yyyy");
  } catch {
    return "";
  }
};
